import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BASE_URL } from '@edl-development/edl-common';
import { ObservationTypeValues } from 'src/app/model/enum/observation-type-values.enum';
import { ComponentsReportDTO } from 'src/app/model/reporting/components-report-dto.model';
import { EEARIndividualDTO } from 'src/app/model/reporting/educator-effectiveness-annual-report-dto.model';
import { EvaluatorCompletionReportDTO } from 'src/app/model/reporting/evaluator-completion-report-dto.model';
import { GrowthAndStrengthReportDTO } from 'src/app/model/reporting/growth-and-strength-report-dto.model';
import { ObservationSummaryReportDTO } from 'src/app/model/reporting/observation-summary-report-dto.model';
import { PaetepApi } from '../paetep/paetep.api';

@Injectable()
export class ReportingApi extends PaetepApi {


    constructor(
        @Inject(BASE_URL) private baseUri: string,
        private http: HttpClient
    ) {
        super();
    }

    getObservationTypes = () => {
        return this.http.get<ObservationTypeValues[]>(`${this.baseUri}/reporting/observationTypes`);
    }

    getComponentReport(bid: number, schoolYear: string, ascending: boolean, orderBy?: string) {
        let params = new HttpParams()
            .append('ascending', String(ascending))

        if (orderBy) {
            params = params.append('orderBy', this.convertParam(orderBy));
        }

        return this.http.get<ComponentsReportDTO[]>(`${this.baseUri}/reporting/component/${bid}/${schoolYear}`, { params });
    }

    downloadComponentReport(bid: number, schoolYear: string, ascending: boolean, orderBy?: string) {
        let params = new HttpParams()
            .append('ascending', String(ascending))

        if (orderBy) {
            params = params.append('orderBy', this.convertParam(orderBy));
        }

        return this.http.get(`${this.baseUri}/reporting/component/download/${bid}/${schoolYear}`, { params, responseType: 'blob' });
    }

    getObservationSummaryReport(schoolYear: string, ascending: boolean, orderBy?: string, bid?: number) {
        let params = new HttpParams()
            .append('ascending', String(ascending))

        if (orderBy) {
            params = params.append('orderBy', this.convertParam(orderBy));
        }

        if (bid) {
            params = params.append('bid', bid);
        }

        return this.http.get<ObservationSummaryReportDTO[]>(`${this.baseUri}/reporting/observationSummary/${schoolYear}`, { params });
    }

    downloadObservationSummaryReport(schoolYear: string, ascending: boolean, orderBy?: string, bid?: number) {
        let params = new HttpParams()
            .append('ascending', String(ascending))

        if (orderBy) {
            params = params.append('orderBy', this.convertParam(orderBy));
        }

        if (bid) {
            params = params.append('bid', bid);
        }

        return this.http.get(`${this.baseUri}/reporting/observationSummary/download/${schoolYear}`, { params, responseType: 'blob' });
    }

    getGrowthAndStrengthReport(bid: number, schoolYear: string, ascending: boolean, orderBy?: string) {
        let params = new HttpParams()
            .append('ascending', String(ascending))

        if (orderBy) {
            params = params.append('orderBy', this.convertParam(orderBy));
        }

        return this.http.get<GrowthAndStrengthReportDTO[]>(`${this.baseUri}/reporting/growthAndStrength/${bid}/${schoolYear}`, { params });
    }

    downloadGrowthAndStrengthReport(bid: number, schoolYear: string, ascending: boolean, orderBy?: string) {
        let params = new HttpParams()
            .append('ascending', String(ascending))

        if (orderBy) {
            params = params.append('orderBy', this.convertParam(orderBy));
        }

        return this.http.get(`${this.baseUri}/reporting/growthAndStrength/download/${bid}/${schoolYear}`, { params, responseType: 'blob' });
    }

    // EEAR
    getEducatorEffectivenessAnnualReportIndividual(bid: number, schoolYear: string, ratingFormType: number, ascending: boolean, orderBy?: string) {
        let params = new HttpParams()
            .append('ascending', String(ascending))

        if (orderBy) {
            params = params.append('orderBy', this.convertParam(orderBy));
        }

        return this.http.get<EEARIndividualDTO[]>(`${this.baseUri}/reporting/educatorEffectivenessAnnualReportIndividual/${ratingFormType}/${bid}/${schoolYear}`, { params });
    }

    downloadEducatorEffectivenessAnnualReportIndividual(bid: number, schoolYear: string, ratingFormType: number, ascending: boolean, orderBy?: string) {
        let params = new HttpParams()
            .append('ascending', String(ascending))

        if (orderBy) {
            params = params.append('orderBy', this.convertParam(orderBy));
        }

        return this.http.get(`${this.baseUri}/reporting/educatorEffectivenessAnnualReportIndividual/download/${ratingFormType}/${bid}/${schoolYear}`, { params, responseType: 'blob' });
    }

    getEducatorEffectivenessAnnualReportBuilding(bid: number, schoolYear: string, ratingFormType: number, ascending: boolean, orderBy?: string) {
        let params = new HttpParams()
            .append('ascending', String(ascending))

        if (orderBy) {
            params = params.append('orderBy', this.convertParam(orderBy));
        }

        return this.http.get<EEARIndividualDTO[]>(`${this.baseUri}/reporting/educatorEffectivenessAnnualReportBuilding/${ratingFormType}/${bid}/${schoolYear}`, { params });
    }

    downloadEducatorEffectivenessAnnualReportBuilding(bid: number, schoolYear: string, ratingFormType: number, ascending: boolean, orderBy?: string) {
        let params = new HttpParams()
            .append('ascending', String(ascending))

        if (orderBy) {
            params = params.append('orderBy', this.convertParam(orderBy));
        }

        return this.http.get(`${this.baseUri}/reporting/educatorEffectivenessAnnualReportBuilding/download/${ratingFormType}/${bid}/${schoolYear}`, { params, responseType: 'blob' });
    }

    //rating form completion report
    getRatingFormCompletionReport(bid: number, schoolYear: string, ratingType: string | undefined, evaluationIntervals?: string | undefined, signatureFilterBy?: string | undefined, filterBySearchBy?: string | undefined) {
        let params = new HttpParams();

        if(ratingType){
            params = params.append('ratingType', this.convertParam(ratingType));
        }
        if (evaluationIntervals) {
            params = params.append('evaluationIntervals', this.convertParam(evaluationIntervals));
        }
        if (signatureFilterBy) {
            params = params.append('signatureFilterBy', this.convertParam(signatureFilterBy));
        }
        if (filterBySearchBy) {
            params = params.append('filterBySearchBy', this.convertParam(filterBySearchBy));
        }
        return this.http.get(`${this.baseUri}/reporting/ratingFormCompletionReport/${bid}/${schoolYear}`, { params });
    }

        //rating form completion report
    downloadRatingFormCompletionReport(bid: number, schoolYear: string, ratingType: string | undefined, evaluationIntervals?: string | undefined, signatureFilterBy?: string | undefined, filterBySearchBy?: string | undefined) {
        let params = new HttpParams();
        if(ratingType){
            params = params.append('ratingType', this.convertParam(ratingType));
        }
        if (evaluationIntervals) {
            params = params.append('evaluationIntervals', this.convertParam(evaluationIntervals));
        }
        if (signatureFilterBy) {
            params = params.append('signatureFilterBy', this.convertParam(signatureFilterBy));
        }
        if (filterBySearchBy) {
            params = params.append('filterBySearchBy', this.convertParam(filterBySearchBy));
        }

        return this.http.get(`${this.baseUri}/reporting/exportRatingFormCompletionReport/${bid}/${schoolYear}`, { params , responseType: 'blob'});
    }

     getRatingFormMissingReport(bid: number, schoolYear: string, filterBySearchBy: string | undefined) {
        let params = new HttpParams();


        if (filterBySearchBy) {
            params = params.append('filterBySearchBy', this.convertParam(filterBySearchBy));
        }
        return this.http.get(`${this.baseUri}/reporting/ratingFormMissingReport/${bid}/${schoolYear}`, { params });
    }


    downloadRatingFormMissingFormsReport(bid: number, schoolYear: string, filterBySearchBy: string | undefined) {
        let params = new HttpParams();

        if (filterBySearchBy) {
            params = params.append('filterBySearchBy', this.convertParam(filterBySearchBy));
        }

        return this.http.get(`${this.baseUri}/reporting/exportRatingFormMissingFormsReport/${bid}/${schoolYear}`, { params , responseType: 'blob'});
    }


    /**
     * Retrieves evaluator completion report data for a date range with optional filters and sorting.
     *
     * @param startDate - Start date for the report range.
     * @param endDate - End date for the report range.
     * @param evaluatorId - Optional evaluator identifier to filter results.
     * @param buildingIds - Optional list of building IDs to filter results.
     * @param orderBy - Optional field name to sort by.
     * @param ascending - Optional sort direction; true for ascending, false for descending.
     * @returns Evaluator completion report response from the reporting API.
     */
    getEvaluatorCompletionReport({
        startDate, 
        endDate, 
        evaluatorId, 
        buildingIds, 
        orderBy, 
        ascending
    }: {
        startDate: string, 
        endDate: string, 
        evaluatorId?: string, 
        buildingIds?: number[], 
        orderBy?: string, 
        ascending?: boolean
    }) {
        let params = new HttpParams()
            .append('startDate', startDate)
            .append('endDate', endDate);

        params = this.appendIfPresent(params, 'evaluatorId', evaluatorId);
        params = this.appendIfPresent(params, 'orderBy', orderBy);
        params = this.appendIfPresent(params, 'ascending', ascending);

        (buildingIds ?? []).forEach(buildingId => {
            params = params.append('buildingIds', String(buildingId));
        });

        return this.http.get<EvaluatorCompletionReportDTO[]>(`${this.baseUri}/reporting/evaluatorCompletionReport`, { params });
    }
}
